import { render, staticRenderFns } from "./shopAuthority.vue?vue&type=template&id=b5833694&scoped=true&"
import script from "./shopAuthority.vue?vue&type=script&lang=js&"
export * from "./shopAuthority.vue?vue&type=script&lang=js&"
import style0 from "./shopAuthority.vue?vue&type=style&index=0&id=b5833694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5833694",
  null
  
)

export default component.exports